import { render, staticRenderFns } from "./CompliancePlaceholder.vue?vue&type=template&id=4debbb45&scoped=true&lang=pug"
import script from "./CompliancePlaceholder.vue?vue&type=script&lang=ts"
export * from "./CompliancePlaceholder.vue?vue&type=script&lang=ts"
import style0 from "./CompliancePlaceholder.vue?vue&type=style&index=0&id=4debbb45&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4debbb45",
  null
  
)

export default component.exports